import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useSEO } from '@/hooks/useSEO';

const regioes = [
  {
    id: 'agreste',
    nome: 'Agreste Pernambucano',
    sede: true,
    cor: '#E8610A',
    corBg: 'bg-orange-50',
    corBorda: 'border-orange-200',
    corTag: 'bg-[#E8610A] text-white',
    corTagSecundaria: 'bg-orange-100 text-orange-800',
    icon: 'ri-store-2-line',
    descricao: 'Nossa sede fica em Caruaru, coração do Agreste. Atendemos toda a região com showroom físico, entrega expressa e equipe técnica local.',
    prazo: 'Entrega em até 5 dias úteis',
    destaque: 'Showroom físico disponível',
    cidades: [
      { nome: 'Caruaru', sede: true },
      { nome: 'Bezerros' },
      { nome: 'Gravatá' },
      { nome: 'Santa Cruz do Capibaribe' },
      { nome: 'Toritama' },
      { nome: 'Surubim' },
      { nome: 'Belo Jardim' },
      { nome: 'Pesqueira' },
      { nome: 'Brejo da Madre de Deus' },
      { nome: 'São Caetano' },
      { nome: 'Agrestina' },
      { nome: 'Cachoeirinha' },
      { nome: 'Cupira' },
      { nome: 'Riacho das Almas' },
      { nome: 'Altinho' },
      { nome: 'Sanharó' },
      { nome: 'Alagoinha' },
      { nome: 'Tacaimbó' },
      { nome: 'Poção' },
      { nome: 'Jataúba' },
      { nome: 'São Bento do Una' },
      { nome: 'Casinhas' },
    ],
    keywords: ['móveis para escritório Caruaru', 'cadeiras ergonômicas Caruaru', 'móveis corporativos Agreste'],
  },
  {
    id: 'rmr',
    nome: 'Região Metropolitana do Recife',
    sede: false,
    cor: '#1a6b3c',
    corBg: 'bg-emerald-50',
    corBorda: 'border-emerald-200',
    corTag: 'bg-emerald-700 text-white',
    corTagSecundaria: 'bg-emerald-100 text-emerald-800',
    icon: 'ri-building-2-line',
    descricao: 'Atendemos toda a Grande Recife com entrega e montagem inclusos. Projetos corporativos de grande porte para empresas, clínicas e órgãos públicos.',
    prazo: 'Entrega em até 7 dias úteis',
    destaque: 'Projetos corporativos de grande porte',
    cidades: [
      { nome: 'Recife' },
      { nome: 'Olinda' },
      { nome: 'Jaboatão dos Guararapes' },
      { nome: 'Paulista' },
      { nome: 'Camaragibe' },
      { nome: 'São Lourenço da Mata' },
      { nome: 'Abreu e Lima' },
      { nome: 'Igarassu' },
      { nome: 'Itapissuma' },
      { nome: 'Araçoiaba' },
      { nome: 'Ilha de Itamaracá' },
      { nome: 'Moreno' },
      { nome: 'Cabo de Santo Agostinho' },
      { nome: 'Ipojuca' },
      { nome: 'Escada' },
      { nome: 'Paudalho' },
      { nome: 'Vitória de Santo Antão' },
    ],
    keywords: ['móveis corporativos Recife', 'cadeiras ergonômicas Recife', 'escritório corporativo Recife'],
  },
  {
    id: 'sertao',
    nome: 'Sertão Pernambucano',
    sede: false,
    cor: '#7c3d12',
    corBg: 'bg-amber-50',
    corBorda: 'border-amber-200',
    corTag: 'bg-amber-700 text-white',
    corTagSecundaria: 'bg-amber-100 text-amber-800',
    icon: 'ri-sun-line',
    descricao: 'Levamos mobiliário corporativo de qualidade até o Sertão. Entrega programada com prazo garantido e instalação no local.',
    prazo: 'Entrega em até 10 dias úteis',
    destaque: 'Atendimento a prefeituras e licitações',
    cidades: [
      { nome: 'Petrolina' },
      { nome: 'Salgueiro' },
      { nome: 'Serra Talhada' },
      { nome: 'Araripina' },
      { nome: 'Ouricuri' },
      { nome: 'Floresta' },
      { nome: 'Arcoverde' },
      { nome: 'Afogados da Ingazeira' },
      { nome: 'Triunfo' },
      { nome: 'Exu' },
      { nome: 'Bodocó' },
      { nome: 'Santa Maria da Boa Vista' },
      { nome: 'Cabrobó' },
      { nome: 'Belém do São Francisco' },
      { nome: 'Inajá' },
      { nome: 'Custódia' },
    ],
    keywords: ['móveis corporativos Petrolina', 'cadeiras escritório Serra Talhada', 'móveis Sertão PE'],
  },
  {
    id: 'zona-mata',
    nome: 'Zona da Mata',
    sede: false,
    cor: '#166534',
    corBg: 'bg-green-50',
    corBorda: 'border-green-200',
    corTag: 'bg-green-700 text-white',
    corTagSecundaria: 'bg-green-100 text-green-800',
    icon: 'ri-plant-line',
    descricao: 'Atendemos municípios da Zona da Mata com soluções completas de mobiliário para escritórios, escolas e órgãos públicos.',
    prazo: 'Entrega em até 7 dias úteis',
    destaque: 'Mobiliário escolar e corporativo',
    cidades: [
      { nome: 'Palmares' },
      { nome: 'Ribeirão' },
      { nome: 'Barreiros' },
      { nome: 'Catende' },
      { nome: 'Água Preta' },
      { nome: 'Quipapá' },
      { nome: 'Gameleira' },
      { nome: 'Sirinhaém' },
      { nome: 'Rio Formoso' },
      { nome: 'Tamandaré' },
      { nome: 'Maraial' },
      { nome: 'Cortês' },
      { nome: 'Amaraji' },
      { nome: 'Primavera' },
      { nome: 'Xexéu' },
    ],
    keywords: ['móveis corporativos Zona da Mata PE', 'cadeiras escritório Palmares', 'mobiliário escolar PE'],
  },
  {
    id: 'sao-francisco',
    nome: 'Vale do São Francisco',
    sede: false,
    cor: '#1e40af',
    corBg: 'bg-blue-50',
    corBorda: 'border-blue-200',
    corTag: 'bg-blue-700 text-white',
    corTagSecundaria: 'bg-blue-100 text-blue-800',
    icon: 'ri-water-flash-line',
    descricao: 'Região do Vale do São Francisco com crescimento acelerado. Atendemos projetos corporativos, licitações e órgãos públicos.',
    prazo: 'Entrega em até 10 dias úteis',
    destaque: 'Polo de crescimento econômico',
    cidades: [
      { nome: 'Petrolina' },
      { nome: 'Lagoa Grande' },
      { nome: 'Santa Maria da Boa Vista' },
      { nome: 'Orocó' },
      { nome: 'Cabrobó' },
      { nome: 'Afrânio' },
      { nome: 'Dormentes' },
      { nome: 'Terra Nova' },
      { nome: 'Itacuruba' },
    ],
    keywords: ['móveis corporativos Petrolina', 'escritório Vale do São Francisco', 'cadeiras ergonômicas Petrolina'],
  },
  {
    id: 'litoral',
    nome: 'Litoral Norte e Sul',
    sede: false,
    cor: '#0e7490',
    corBg: 'bg-cyan-50',
    corBorda: 'border-cyan-200',
    corTag: 'bg-cyan-700 text-white',
    corTagSecundaria: 'bg-cyan-100 text-cyan-800',
    icon: 'ri-sailboat-line',
    descricao: 'Atendemos municípios do litoral pernambucano com foco em hotéis, pousadas, clínicas e escritórios de turismo.',
    prazo: 'Entrega em até 7 dias úteis',
    destaque: 'Hotéis, pousadas e turismo',
    cidades: [
      { nome: 'Porto de Galinhas' },
      { nome: 'Ipojuca' },
      { nome: 'Tamandaré' },
      { nome: 'Barreiros' },
      { nome: 'São José da Coroa Grande' },
      { nome: 'Goiana' },
      { nome: 'Itamaracá' },
      { nome: 'Itapissuma' },
      { nome: 'Sirinhaém' },
      { nome: 'Rio Formoso' },
    ],
    keywords: ['móveis para hotel Porto de Galinhas', 'mobiliário pousada litoral PE', 'escritório turismo Pernambuco'],
  },
];

const stats = [
  { valor: '100+', label: 'Cidades atendidas em PE' },
  { valor: '10+', label: 'Anos de experiência' },
  { valor: '500+', label: 'Projetos entregues' },
  { valor: '5', label: 'Regiões cobertas' },
];

const segmentos = [
  { icon: 'ri-building-2-line', label: 'Escritórios Corporativos', desc: 'Projetos completos para empresas de todos os portes' },
  { icon: 'ri-school-line', label: 'Escolas e Universidades', desc: 'Mobiliário escolar conforme normas ABNT e FNDE' },
  { icon: 'ri-government-line', label: 'Prefeituras e Órgãos Públicos', desc: 'Licitações e atas de registro de preços em todo PE' },
  { icon: 'ri-hospital-line', label: 'Clínicas e Hospitais', desc: 'Recepções, consultórios e áreas administrativas' },
  { icon: 'ri-store-2-line', label: 'Comércio e Varejo', desc: 'Ambientes comerciais funcionais e atrativos' },
  { icon: 'ri-bank-line', label: 'Bancos e Financeiras', desc: 'Mobiliário para agências e escritórios financeiros' },
  { icon: 'ri-hotel-line', label: 'Hotéis e Pousadas', desc: 'Recepções, lobbies e áreas de trabalho' },
  { icon: 'ri-home-office-line', label: 'Home Office', desc: 'Cadeiras ergonômicas e mesas para trabalho remoto' },
];

const diferenciais = [
  { icon: 'ri-truck-line', titulo: 'Entrega em todo PE', desc: 'Entregamos em qualquer cidade de Pernambuco com prazo garantido e rastreamento em tempo real.' },
  { icon: 'ri-tools-line', titulo: 'Montagem inclusa', desc: 'Nossa equipe técnica realiza a montagem e instalação no local, sem custo adicional para o cliente.' },
  { icon: 'ri-file-list-3-line', titulo: 'Licitações públicas', desc: 'Participamos de processos licitatórios em todo o estado com documentação completa e produtos certificados.' },
  { icon: 'ri-customer-service-2-line', titulo: 'Suporte pós-venda', desc: 'Acompanhamento após a entrega com garantia de fábrica e assistência técnica especializada.' },
  { icon: 'ri-map-pin-2-line', titulo: 'Showroom em Caruaru', desc: 'Agende uma visita com hora marcada e experimente os produtos com calma, sem pressa e com atenção exclusiva.' },
  { icon: 'ri-shield-check-line', titulo: 'Garantia de fábrica', desc: 'Todos os produtos têm garantia de fábrica de 1 a 5 anos, conforme a marca e o modelo.' },
];

export default function AreaAtendimentoPage() {
  const [regiaoAtiva, setRegiaoAtiva] = useState<string>('agreste');

  useSEO({
    title: 'Área de Atendimento em Pernambuco | Móveis Corporativos – Home Office Premium Caruaru',
    description: 'A Home Office Premium atende mais de 100 cidades em Pernambuco: Caruaru, Recife, Petrolina, Serra Talhada, Garanhuns e todo o interior. Móveis corporativos, cadeiras ergonômicas e projetos completos com entrega e montagem inclusos.',
    keywords: 'móveis corporativos Pernambuco, cadeiras ergonômicas Caruaru, móveis escritório Recife, cadeiras escritório Caruaru, móveis corporativos Petrolina, entrega móveis PE, Home Office Premium área de atendimento',
    path: '/area-de-atendimento',
    ogTitle: 'Área de Atendimento | Home Office Premium – Pernambuco',
    ogDescription: 'Atendemos mais de 100 cidades em Pernambuco. Cadeiras ergonômicas, mesas corporativas, entrega e montagem inclusos em todo o estado.',
  });

  useEffect(() => {
    const schemaId = 'schema-area-atendimento';
    let script = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!script) { script = document.createElement('script'); script.id = schemaId; script.type = 'application/ld+json'; document.head.appendChild(script); }
    script.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'Home Office Premium',
      description: 'Especialistas em mobiliário corporativo em Caruaru PE. Atendemos mais de 100 cidades em todo o estado de Pernambuco com entrega e montagem inclusos.',
      url: import.meta.env.VITE_SITE_URL ?? '',
      telephone: '+5581982030285',
      email: 'ednilsonleocadio@gmail.com',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Av. Agamenon Magalhães, 1519',
        addressLocality: 'Caruaru',
        addressRegion: 'PE',
        postalCode: '55014-000',
        addressCountry: 'BR',
      },
      geo: { '@type': 'GeoCoordinates', latitude: -8.2836, longitude: -36.0078 },
      areaServed: regioes.flatMap(r => r.cidades).map(c => ({
        '@type': 'City',
        name: c.nome,
        containedInPlace: { '@type': 'State', name: 'Pernambuco', containedInPlace: { '@type': 'Country', name: 'Brasil' } },
      })),
      openingHoursSpecification: [
        { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday'], opens: '08:00', closes: '18:00' },
        { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday'], opens: '09:00', closes: '13:00' },
      ],
    });

    const breadcrumbId = 'schema-area-breadcrumb';
    let bcScript = document.getElementById(breadcrumbId) as HTMLScriptElement | null;
    if (!bcScript) { bcScript = document.createElement('script'); bcScript.id = breadcrumbId; bcScript.type = 'application/ld+json'; document.head.appendChild(bcScript); }
    bcScript.textContent = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: import.meta.env.VITE_SITE_URL ?? '' },
        { '@type': 'ListItem', position: 2, name: 'Área de Atendimento', item: `${import.meta.env.VITE_SITE_URL ?? ''}/area-de-atendimento` },
      ],
    });
    return () => { script?.remove(); bcScript?.remove(); };
  }, []);

  const regiaoSelecionada = regioes.find(r => r.id === regiaoAtiva) ?? regioes[0];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero */}
      <section className="relative pt-20 overflow-hidden">
        <div className="relative h-[420px] md:h-[520px]">
          <img
            src="/media/ia/0243.webp"
            alt="Área de atendimento Pernambuco – Home Office Premium"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/55 to-black/20"></div>
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto px-6 w-full">
              <nav className="flex items-center gap-2 text-xs text-white/50 mb-6">
                <Link to="/" className="hover:text-white transition-colors">Home</Link>
                <i className="ri-arrow-right-s-line"></i>
                <span className="text-white/80">Área de Atendimento</span>
              </nav>
              <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Pernambuco inteiro</p>
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-5 leading-tight">
                Atendemos mais de<br />
                <span className="text-[#E8610A]">100 cidades</span> em<br />
                Pernambuco
              </h1>
              <p className="text-white/70 text-base max-w-xl leading-relaxed mb-8">
                Da nossa sede em <strong className="text-white">Caruaru</strong> até Recife, Petrolina, Serra Talhada e todo o interior — entregamos e instalamos móveis corporativos em qualquer cidade pernambucana.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/contato"
                  className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white text-sm font-semibold px-7 py-3.5 rounded-full hover:bg-[#C4500A] transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-message-3-line"></i>
                  Solicitar Orçamento
                </Link>
                <a
                  href="https://wa.me/5581982030285?text=Oi%2C%20tudo%20bem%3F%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white text-sm font-semibold px-7 py-3.5 rounded-full hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line"></i>
                  Falar no WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats bar */}
      <section className="bg-[#E8610A]">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map(s => (
              <div key={s.label} className="text-center">
                <p className="text-white text-3xl font-bold leading-none mb-1">{s.valor}</p>
                <p className="text-orange-100 text-xs">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mapa + intro */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">
          <div>
            <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Nossa cobertura</p>
            <h2 className="text-3xl font-bold text-gray-900 mb-5 leading-tight">
              Móveis corporativos com entrega em todo o estado de Pernambuco
            </h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-4">
              A <strong>Home Office Premium</strong>, com sede em <strong>Caruaru – PE</strong>, é referência em mobiliário corporativo no Agreste Pernambucano e atende empresas, escolas, prefeituras e órgãos públicos em todo o estado.
            </p>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Trabalhamos com as melhores marcas do mercado — <strong>Frisokar</strong>, <strong>Plaxmetal</strong>, <strong>Marzo Vitorino</strong> e <strong>W3</strong> — e oferecemos projetos completos com entrega, montagem e suporte pós-venda em qualquer cidade pernambucana.
            </p>

            {/* Keywords SEO visíveis */}
            <div className="bg-[#F9F6F3] rounded-2xl p-5 mb-6">
              <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">Principais regiões atendidas</p>
              <div className="flex flex-wrap gap-2">
                {[
                  'Móveis corporativos Recife',
                  'Cadeiras ergonômicas Caruaru',
                  'Móveis escritório Petrolina',
                  'Cadeiras escritório Caruaru',
                  'Móveis corporativos Pernambuco',
                  'Escritório corporativo Recife',
                  'Cadeiras ergonômicas Pernambuco',
                  'Móveis escritório Caruaru',
                  'Licitação móveis PE',
                  'Mobiliário escolar Pernambuco',
                ].map(kw => (
                  <span key={kw} className="text-xs bg-white border border-gray-200 text-gray-600 px-3 py-1.5 rounded-full">
                    {kw}
                  </span>
                ))}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/contato"
                className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-[#C4500A] transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-message-3-line"></i>
                Solicitar Orçamento Grátis
              </Link>
              <a
                href="https://wa.me/5581982030285?text=Oi%2C%20tudo%20bem%3F%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 border border-gray-200 text-gray-700 text-sm font-semibold px-6 py-3 rounded-full hover:border-[#E8610A] hover:text-[#E8610A] transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
                Chamar no WhatsApp
              </a>
            </div>
          </div>

          {/* Mapa Google Maps – Pernambuco */}
          <div className="space-y-4">
            <div className="rounded-2xl overflow-hidden border border-gray-100" style={{ height: '380px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1985000!2d-37.5!3d-8.3!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7061a4e7b7b7b7b7%3A0x1234567890abcdef!2sPernambuco%2C%20Brasil!5e0!3m2!1spt-BR!2sbr!4v1700000000001!5m2!1spt-BR!2sbr"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Área de atendimento Home Office Premium – Pernambuco"
              ></iframe>
            </div>
            {/* Localização da sede */}
            <div className="bg-[#F9F6F3] rounded-2xl p-5 flex items-start gap-4">
              <div className="w-10 h-10 flex items-center justify-center bg-[#E8610A]/10 rounded-xl flex-shrink-0">
                <i className="ri-map-pin-2-line text-[#E8610A] text-lg"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-900 mb-0.5">Sede – Caruaru, PE</p>
                <p className="text-xs text-gray-500 leading-relaxed">Av. Agamenon Magalhães, 1519 – Maurício de Nassau<br />CEP 55014-000 · Caruaru – Pernambuco</p>
                <a
                  href="https://maps.google.com/?q=Av.+Agamenon+Magalhães,+1519,+Caruaru,+PE"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-[#E8610A] text-xs font-medium mt-2 hover:underline cursor-pointer"
                >
                  <i className="ri-external-link-line"></i>
                  Ver no Google Maps
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Regiões interativas */}
      <section className="bg-[#F9F6F3] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-10">
            <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Cobertura por região</p>
            <h2 className="text-2xl font-bold text-gray-900 mb-3">Cidades atendidas em Pernambuco</h2>
            <p className="text-gray-500 text-sm max-w-xl mx-auto">
              Selecione uma região para ver as cidades atendidas, prazo de entrega e diferenciais do atendimento.
            </p>
          </div>

          {/* Tabs de regiões */}
          <div className="flex flex-wrap gap-2 justify-center mb-8">
            {regioes.map(r => (
              <button
                key={r.id}
                onClick={() => setRegiaoAtiva(r.id)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  regiaoAtiva === r.id
                    ? 'bg-[#E8610A] text-white'
                    : 'bg-white border border-gray-200 text-gray-600 hover:border-[#E8610A]/40 hover:text-[#E8610A]'
                }`}
              >
                <i className={`${r.icon} text-sm`}></i>
                {r.nome}
                {r.sede && <span className="text-xs bg-white/20 px-1.5 py-0.5 rounded-full">Sede</span>}
              </button>
            ))}
          </div>

          {/* Painel da região selecionada */}
          <div className={`rounded-2xl border p-8 ${regiaoSelecionada.corBg} ${regiaoSelecionada.corBorda}`}>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Info */}
              <div className="lg:col-span-1">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-white rounded-xl">
                    <i className={`${regiaoSelecionada.icon} text-lg`} style={{ color: regiaoSelecionada.cor }}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <h3 className="text-gray-900 font-bold text-base">{regiaoSelecionada.nome}</h3>
                      {regiaoSelecionada.sede && (
                        <span className="text-xs bg-[#E8610A] text-white px-2 py-0.5 rounded-full font-medium">Sede</span>
                      )}
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-5">{regiaoSelecionada.descricao}</p>
                <div className="space-y-3">
                  <div className="flex items-center gap-2 text-sm">
                    <i className="ri-time-line text-[#E8610A]"></i>
                    <span className="text-gray-700 font-medium">{regiaoSelecionada.prazo}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm">
                    <i className="ri-star-line text-[#E8610A]"></i>
                    <span className="text-gray-700">{regiaoSelecionada.destaque}</span>
                  </div>
                </div>
                <div className="mt-5">
                  <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-2">Keywords desta região</p>
                  <div className="flex flex-wrap gap-1.5">
                    {regiaoSelecionada.keywords.map(kw => (
                      <span key={kw} className="text-xs bg-white/70 text-gray-600 px-2.5 py-1 rounded-full border border-white">
                        {kw}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              {/* Cidades */}
              <div className="lg:col-span-2">
                <p className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-4">
                  {regiaoSelecionada.cidades.length} cidades atendidas
                </p>
                <div className="flex flex-wrap gap-2">
                  {regiaoSelecionada.cidades.map(cidade => (
                    <span
                      key={cidade.nome}
                      className={`text-xs px-3 py-1.5 rounded-full font-medium ${
                        cidade.sede
                          ? 'bg-[#E8610A] text-white'
                          : 'bg-white text-gray-700 border border-gray-200'
                      }`}
                    >
                      {cidade.nome}
                      {cidade.sede && <span className="ml-1 opacity-70">★</span>}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Por que escolher a Home Office Premium</p>
          <h2 className="text-2xl font-bold text-gray-900">Atendimento completo, de ponta a ponta</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {diferenciais.map(d => (
            <div key={d.titulo} className="bg-[#F9F6F3] rounded-2xl p-6 border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center bg-[#E8610A]/10 rounded-xl mb-4">
                <i className={`${d.icon} text-[#E8610A] text-xl`}></i>
              </div>
              <h3 className="text-gray-900 font-semibold text-sm mb-2">{d.titulo}</h3>
              <p className="text-gray-500 text-sm leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Segmentos */}
      <section className="bg-[#111111] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Quem atendemos</p>
            <h2 className="text-2xl font-bold text-white mb-3">Segmentos atendidos em todo Pernambuco</h2>
            <p className="text-gray-400 text-sm max-w-xl mx-auto">
              Da pequena empresa ao grande projeto corporativo, atendemos todos os segmentos com soluções personalizadas e entrega garantida.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {segmentos.map(seg => (
              <div key={seg.label} className="bg-white/5 rounded-2xl p-5 border border-white/5 hover:border-[#E8610A]/30 transition-colors">
                <div className="w-12 h-12 flex items-center justify-center bg-[#E8610A]/10 rounded-xl mb-4">
                  <i className={`${seg.icon} text-[#E8610A] text-xl`}></i>
                </div>
                <p className="text-white text-sm font-semibold mb-1">{seg.label}</p>
                <p className="text-gray-500 text-xs leading-relaxed">{seg.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mapa sede + contato */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Nossa sede</p>
            <h2 className="text-2xl font-bold text-gray-900 mb-5">Visite nosso showroom em Caruaru — com hora marcada</h2>
            <p className="text-gray-600 text-sm leading-relaxed mb-6">
              Nosso showroom em Caruaru funciona com hora marcada. Agende pelo WhatsApp no melhor dia e horário pra você (sim, sábado à noite e domingo também!) e venha conhecer os produtos com calma, testar as cadeiras ergonômicas e conversar com a gente sem interrupção. Café e bolo te esperam.
            </p>
            <div className="space-y-4 mb-8">
              {[
                { icon: 'ri-map-pin-2-line', label: 'Endereço', value: 'Av. Agamenon Magalhães, 1519 – Maurício de Nassau, Caruaru – PE, CEP 55014-000' },
                { icon: 'ri-time-line', label: 'Horário', value: 'Seg–Sex: 08h às 18h · Sáb: 09h às 13h' },
                { icon: 'ri-whatsapp-line', label: 'WhatsApp', value: '(81) 98203-0285' },
                { icon: 'ri-mail-line', label: 'E-mail', value: 'ednilsonleocadio@gmail.com' },
              ].map(item => (
                <div key={item.label} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center bg-[#E8610A]/10 rounded-xl flex-shrink-0">
                    <i className={`${item.icon} text-[#E8610A] text-base`}></i>
                  </div>
                  <div>
                    <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest mb-0.5">{item.label}</p>
                    <p className="text-sm text-gray-700">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/contato"
                className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-[#C4500A] transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-message-3-line"></i>
                Solicitar Orçamento
              </Link>
              <a
                href="https://wa.me/5581982030285?text=Oi%2C%20tudo%20bem%3F%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white text-sm font-semibold px-6 py-3 rounded-full hover:bg-[#1ebe5d] transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line"></i>
                Chamar no WhatsApp
              </a>
            </div>
          </div>

          {/* Mapa da sede */}
          <div className="rounded-2xl overflow-hidden border border-gray-100" style={{ height: '420px' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3924.3!2d-36.0078!3d-8.2836!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7061a4e7b7b7b7b7%3A0x1234567890abcdef!2sAv.%20Agamenon%20Magalh%C3%A3es%2C%201519%20-%20Maur%C3%ADcio%20de%20Nassau%2C%20Caruaru%20-%20PE%2C%2055014-000!5e0!3m2!1spt-BR!2sbr!4v1700000000002!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Home Office Premium – Showroom Caruaru PE"
            ></iframe>
          </div>
        </div>
      </section>

      {/* CTA final */}
      <section className="bg-[#F9F6F3] py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <p className="text-[#E8610A] text-xs font-semibold uppercase tracking-widest mb-3">Pronto para começar?</p>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Sua cidade está na nossa área de atendimento
          </h2>
          <p className="text-gray-600 text-sm max-w-lg mx-auto mb-8 leading-relaxed">
            Entre em contato agora e receba um orçamento personalizado para sua empresa. Atendemos em todo o estado de Pernambuco com agilidade, qualidade e garantia.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/contato"
              className="inline-flex items-center justify-center gap-2 bg-[#E8610A] text-white text-sm font-semibold px-8 py-4 rounded-full hover:bg-[#C4500A] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-message-3-line"></i>
              Solicitar Orçamento Grátis
            </Link>
            <a
              href="https://wa.me/5581982030285?text=Oi%2C%20tudo%20bem%3F%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white text-sm font-semibold px-8 py-4 rounded-full hover:bg-[#1ebe5d] transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-line"></i>
              Chamar no WhatsApp
            </a>
          </div>
        </div>
      </section>

      <Footer />

      <a
        href="https://wa.me/5581982030285?text=Oi%2C%20tudo%20bem%3F%20Vim%20pelo%20site%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-[9999] w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full cursor-pointer hover:scale-110 transition-transform duration-200"
        aria-label="WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-2xl"></i>
      </a>
    </div>
  );
}
